import { Alert, AlertTitle } from '@mui/material'
import React from 'react'
import { IGlobalError } from '../../context/GlobalError'

interface Props {
  error?: IGlobalError
  children?: any
}

export const Error: React.FC<Props> = ({ children, error }) => {
  let statusCode = error?.status || 'Error'
  return (
    <>
      <Alert severity="error">
        <AlertTitle>{statusCode}</AlertTitle>
        {String(statusCode) !== String(error?.message) && error?.message}
      </Alert>
      {children}
    </>
  )
}
